import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from "../../shared/common.service";

@Component({
  selector: 'app-study-crc-edit',
  templateUrl: './study-crc-edit.component.html',
  styleUrls: ['./study-crc-edit.component.scss']
})
export class StudyCRCEditComponent implements OnInit {
  cdaDocumentLink: string = '';
  siteActivityChilds: any[] = [];
  form: FormGroup;
  dropdownOptions: { [key: string]: { [field: string]: any[] } } = {};
  routeParams: any;
  groupNames: { [key: string]: string } = {};
  multiForm: FormGroup;
  currentFormIndex = 0;
  missingDocuments: any = [
    {
      item_id: "CTA",
      item_text: "CTA"
    },
    {
      item_id: "Confidentiality Disclosure Agreement",
      item_text: "Confidentiality Disclosure Agreement"
    },
    {
      item_id: "Investigator Undertaking",
      item_text: "Investigator Undertaking"
    },
    {
      item_id: "GMP Certificate",
      item_text: "GMP Certificate"
    },
    {
      item_id: "CRO Agreement",
      item_text: "CRO Agreement"
    },
    {
      item_id: "Central Laboratory Agreement",
      item_text: "Central Laboratory Agreement"
    },
    {
      item_id: "Budget",
      item_text: "Budget"
    },
    {
      item_id: "Insurance Certificate",
      item_text: "Insurance Certificate"
    },
    {
      item_id: "Protocol",
      item_text: "Protocol"
    },
    {
      item_id: "Investigator Brochure",
      item_text: "Investigator Brochure"
    },
    {
      item_id: "Submission letter",
      item_text: "Submission letter"
    },
    {
      item_id: "Approval letter",
      item_text: "Approval letter"
    },
    {
      item_id: "Amendment",
      item_text: "Amendment"
    },
    {
      item_id: "Communication",
      item_text: "Communication"
    },
    {
      item_id: "Queries",
      item_text: "Queries"
    },
    {
      item_id: "Correspondence Amendment",
      item_text: "Correspondence Amendment"
    },
    {
      item_id: "FDA approval",
      item_text: "FDA approval"
    },
    {
      item_id: "CTRI Registration",
      item_text: "CTRI Registration"
    },
    {
      item_id: "Certificate of Analysis",
      item_text: "Certificate of Analysis"
    },
    {
      item_id: "Informed Consent Form (Approved) (Original and Translation Certificate)",
      item_text: "Informed Consent Form (Approved) (Original and Translation Certificate)"
    },
    {
      item_id: "Sponsor contact log",
      item_text: "Sponsor contact log"
    },
    {
      item_id: "CRO contact log",
      item_text: "CRO contact log"
    },
    {
      item_id: "Site contact log",
      item_text: "Site contact log"
    },
    {
      item_id: "Lab Personnel contact log",
      item_text: "Lab Personnel contact log"
    },
    {
      item_id: "IEC contact log",
      item_text: "IEC contact log"
    },
    {
      item_id: "Delegation Log (Site-wise)",
      item_text: "Delegation Log (Site-wise)"
    },
    {
      item_id: "Site Staff CVs",
      item_text: "Site Staff CVs"
    },
    {
      item_id: "MRC",
      item_text: "MRC"
    },
    {
      item_id: "Feasibility visit",
      item_text: "Feasibility visit"
    },
    {
      item_id: "Initiation visit",
      item_text: "Initiation visit"
    },
    {
      item_id: "Staff training log",
      item_text: "Staff training log"
    },
    {
      item_id: "Monitoring visit log",
      item_text: "Monitoring visit log"
    },
    {
      item_id: "Reports",
      item_text: "Reports"
    },
    {
      item_id: "Screening log",
      item_text: "Screening log"
    },
    {
      item_id: "Enrollment log",
      item_text: "Enrollment log"
    },
    {
      item_id: "Scheduled activity log",
      item_text: "Scheduled activity log"
    },
    {
      item_id: "Dropout log",
      item_text: "Dropout log"
    },
    {
      item_id: "Withdraw log",
      item_text: "Withdraw log"
    },
    {
      item_id: "Source",
      item_text: "Source"
    },
    {
      item_id: "Appendix",
      item_text: "Appendix"
    },
    {
      item_id: "AE (Adverse Event) log",
      item_text: "AE (Adverse Event) log"
    },
    {
      item_id: "SAE (Serious Adverse Event)",
      item_text: "SAE (Serious Adverse Event)"
    },
    {
      item_id: "Deviation/Violation Log",
      item_text: "Deviation/Violation Log"
    },
    {
      item_id: "Shipment records",
      item_text: "Shipment records"
    },
    {
      item_id: "Return records",
      item_text: "Return records"
    },
    {
      item_id: "Accountability log",
      item_text: "Accountability log"
    },
    {
      item_id: "Disposition",
      item_text: "Disposition"
    },
    {
      item_id: "Shipment",
      item_text: "Shipment"
    },
    {
      item_id: "Return/Disposition records",
      item_text: "Return/Disposition records"
    },
    {
      item_id: "Accountability log",
      item_text: "Accountability log"
    },
    {
      item_id: "Reference Range for Lab Investigations",
      item_text: "Reference Range for Lab Investigations"
    },
    {
      item_id: "Randomization List",
      item_text: "Randomization List"
    },
    {
      item_id: "Status Reports",
      item_text: "Status Reports"
    },
    {
      item_id: "Correspondence/Communication Records",
      item_text: "Correspondence/Communication Records"
    },
    {
      item_id: "Clinical Study Report",
      item_text: "Clinical Study Report"
    },
    {
      item_id: "Close out report",
      item_text: "Close out report"
    }
  ];
  dropdownSettings: any = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 10,
    allowSearchFilter: true
  };
  relatedEquipment: any = [
    "Weight scale",
    "Hight meter",
    "Glucometer",
    "Lab Kits",
    "Skin Caliper",
    "Actigraphy Watch",
    "Measuring Tape",
    "Refrigerator",
    "Dandruff strips",
    "pH Strips",
    "O2 meter",
  ];
  siteActivitesList = [
    {
      id: 1,
      name: "CDA",
      form: "CDA"
    },
    {
      id: 2,
      name: "Site Feasibility",
      form: "Site_Feasibility"
    },
    {
      id: 5,
      name: "CTA",
      form: "CTA"
    },
    {
      id: 9,
      name: "Document submission to PI",
      form: "DOCUMENT_SUBMISSION_TO_PI"
    },
    {
      id: 13,
      name: "EC Submission",
      form: "EC_Submission"
    },
    {
      id: 14,
      name: "CTRI Status",
      form: "CTRI_Done"
    },
    {
      id: 15,
      name: "IP-NONIP",
      form: "IP_NONIP"
    },
    {
      id: 16,
      name: "Site initiation visit done",
      form: "SITE_INITATION_VISIT_DONE"
    },
    {
      id: 17,
      name: "Running Status",
      form: "RUNNING_STATUS"
    },
    {
      id: 18,
      name: "Data Entry",
      form: "Data_Entry"
    },
    {
      id: 19,
      name: "CSR Sumbission",
      form: "CSR_Sumbission"
    },
    {
      id: 20,
      name: "Close Out",
      form: "Close_Out"
    },
    {
      id:88,
      name: "Publication",
      form: "publication"
    },
    {
      id: 45,
      name: "CTRI Updation",
      form: "CTRI_Updation"
    },
    {
      id: 40,
      name: "Subject Identity Submission",
      form: "Subject_Identity_Submission"
    } 
  ];
  currentFormObject: { id: number; name: string; form: string; };
  queryParams: any;


  
  studyId: number;
  previousPage: number;
  currentPage: number = 1;
  searchParams: any = {}; // Store search params here
  searchCrcName: string = '';
  searchStudyName: string = '';
  searchLocation: string = '';
  searchAssignedBy: string = '';


  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
  ) {
    this.form = this.fb.group({
      selectedOption: [''],
      dynamicForm: this.fb.group({})
    });
    this.routeParams = this.route.snapshot.params;
    this.queryParams = this.route.snapshot.queryParams;
  }

  ngOnInit() {


    
 // Extract study ID from route param
//  this.studyId = +this.route.snapshot.paramMap.get('id');

//  // Extract the 'page' query param
//  this.route.queryParams.subscribe(params => {

//    console.log('Query Params:', params);  // Add this line to debug

//    this.previousPage = +params['page'] || 1;  // Default to page 1 if no 'page' param

//    console.log("Previous Page:", this.previousPage);  // Debugging line

//  });


this.studyId = +this.route.snapshot.paramMap.get('id');
// Capture the query parameters
this.route.queryParams.subscribe(params => {
 this.currentPage = params['page'] || 1;
 this.searchParams.searchCrcName = params['searchCrcName'] || '';
 this.searchParams.searchStudyName = params['searchStudyName'] || '';
 this.searchParams.searchLocation = params['searchLocation'] || '';
 this.searchParams.searchAssignedBy = params['searchAssignedBy'] || '';
});


    this.multiForm = this.fb.group({
      selectedOption: [''],  // Dropdown control
      CDA: this.fb.group({
        "3": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
          input: [''],
        })
      }),
      Site_Feasibility: this.fb.group({
        "4": this.fb.group({
          status: [''],
          comment: [''],
          reason: [''],
          input: [''],
        })
      }),
      CTA: this.fb.group({
        "6": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
          input: [''],
        }),
        "7": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
          input: [''],
        }),
        "8": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
          input: [''],
        })
      }),
      DOCUMENT_SUBMISSION_TO_PI: this.fb.group({
        "10": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "46": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
          // input: [''],
        }),
        "81": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        })
      }),
      EC_Submission: this.fb.group({
        "21": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "22": this.fb.group({
          status: [''],
          input: [],
          comment: [],
        }),
        "23": this.fb.group({
          status: [''],
          date: [],
          reason:[],
        }),
        "24": this.fb.group({
          input: [''],
          date:[],
          
        }),
        "25": this.fb.group({
          input: [''],
          date:[],
        }),
        "82": this.fb.group({
          input: [''],
          date:[],
        }),
        "83": this.fb.group({
          input: [''],
          date:[],
        }),
        "84": this.fb.group({
          input: [''],
          date:[],
        }),
        "85": this.fb.group({
          input: [''],
          date:[],
        }),
      }),
      CTRI_Done: this.fb.group({
        "26": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "27": this.fb.group({
          input: [''],
        }),
      }),
      RUNNING_STATUS: this.fb.group({
        "42": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "68": this.fb.group({
          input: []
        }),
        "69": this.fb.group({
          input: [],
        }),
        "91": this.fb.group({
          input: [],
        }),
        "92": this.fb.group({
          input: [],
        }),
        "86": this.fb.group({
          input: [],
        }),
        "70": this.fb.group({
          input: []
        }),
        "71": this.fb.group({
          input: [],
        }),
        "72": this.fb.group({
          input: [],
        }),
        "73": this.fb.group({
          input: []
        }),
        "74": this.fb.group({
          input: [],
          sub_data: this.fb.group({
            input_1: [],
            input_2: [],
            input_3: [],
            input_4: [],
            input_5: [],
            input_6: [],
            input_7: [],
            
          })
        }),
        "89": this.fb.group({
          input: []
        }),
        "90": this.fb.group({
          input: []
        }),
        "75": this.fb.group({
          input: [],
          sub_data: this.fb.group({
            input_1: []
          })
        }),
      }),
      IP_NONIP: this.fb.group({
        "28": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "29": this.fb.group({
          input: [''],
          date: [],
          quantity: []
        }),
        "64": this.fb.group({
          input: [''],
          date: [],
          quantity: []
        }),
        "65": this.fb.group({
          input: [''],
          date: [],
          quantity: []
        }),
        "66": this.fb.group({
          input: [''],
          date: [],
          quantity: []
        }),
        "67": this.fb.group({
          input: [''],
          date: [],
          quantity: []
        }),
        "51": this.fb.group({
          input: [''],
        }),
        "52": this.fb.group({
          input: [''],
        }),
        "53": this.fb.group({
          input: [''],
        }),
        "54": this.fb.group({
          input: [''],
        }),
        "55": this.fb.group({
          status: [''],
        }),
        "56": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "57": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "58": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "59": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "60": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "61": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "62": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "43": this.fb.group({
          status: ['']
        }),
        "30": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
        "31": this.fb.group({
          status: [''],
          comment: [],
          reason: []
        }),
      }),
      SITE_INITATION_VISIT_DONE: this.fb.group({
        "32": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "33": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "34": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
      }),
      Data_Entry: this.fb.group({
        "36": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "44": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        })
      }),
      CSR_Sumbission: this.fb.group({
        "37": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "38": this.fb.group({
          input: []
        })
      }),
      Subject_Identity_Submission: this.fb.group({
        "41": this.fb.group({
          input: []
        })
      }),
      Close_Out: this.fb.group({
        "39": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        }),
        "76": this.fb.group({
          input: []
        }),
        "77": this.fb.group({
          input: []
        }),
        "78": this.fb.group({
          input: []
        }),
        "79": this.fb.group({
          input: []
        }),
      }),
      publication: this.fb.group({
        "87": this.fb.group({
          status: [''],
          comment: [],
        }),
      }),
      CTRI_Updation: this.fb.group({
        "80": this.fb.group({
          status: [''],
          comment: [],
          reason: [],
        })
      })
    });
    
    this.multiForm.get('selectedOption').valueChanges.subscribe((selectedValue) => {
      this.selectOption(selectedValue);
    });
    if(this.queryParams.selectedOption){
      this.multiForm.get('selectedOption').setValue(this.queryParams.selectedOption);
    }
    let userData = this.commonService.getUserData();
    if (userData == null) {
      this.commonService.logout();
    }
    const params = new HttpParams().set('userId', '1');
    const headers = new HttpHeaders().set('Authorization', 'Bearer my-token');
    // this.apiService.get('api/siteActivitesList', params, headers).subscribe({
    //   next: (response: any[]) => {
    //     this.siteActivitesList = response;
    //   },
    //   error: (error) => {
    //     console.error('Error fetching site activities:', error);
    //     // Handle the error: show a message, redirect, etc.
    //   }
    // });



  }

  selectOption(selectedValue){
    this.currentFormIndex = parseInt(selectedValue);
      for (const element of this.siteActivitesList) {
        if (element.id == this.currentFormIndex) {
          this.currentFormObject = element;
        }
      }
      this.updateForm(selectedValue);
  }
  // Helper function to get the correct form group
  getFormGroupByIndex(index: number): FormGroup {
    const formNames = ['form1', 'form2', 'form3'];
    return this.multiForm.get(this.currentFormObject.form) as FormGroup;
  }

  submitDataToApi(data: any): void {
    // API call logic here
    console.log('Data submitted to the API:', data);
  }

  updateForm(optionId: string) {
    let params = new HttpParams()
      .set('id', optionId)
      .set('study_crc_id', this.routeParams.id);
    this.apiService.get('api/siteActivityChilds', params).subscribe(
      (response: any[]) => {
        this.siteActivityChilds = response;
        response.forEach(child => {
          // if (child.data) {
          // Fill the CDA form with the retrieved data
          if (optionId == "1") {
            const cdaForm = this.multiForm.get('CDA') as FormGroup;
            const newGroupForm = cdaForm.get('3') as FormGroup;
            this.cdaDocumentLink = child.cda_document_link || '';
            newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
              // Enable the comment field if the status is 'Comment'
              if (statusValue === 'Comment') {
                newGroupForm.get('comment').enable();
                newGroupForm.get('reason').disable();
              } else if (statusValue === 'No') {
                newGroupForm.get('reason').enable();
                newGroupForm.get('comment').disable();
              } else {
                newGroupForm.get('comment')?.disable();
                newGroupForm.get('comment')?.setValue('');
                newGroupForm.get('reason')?.disable();
                newGroupForm.get('reason')?.setValue('');
                // Disable and clear the comment field if status is not 'Comment'
                // newGroupForm.get('comment').disable();
                // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
              }
            });

            newGroupForm.get('status').setValue(child?.data?.status || '');
            newGroupForm.get('comment').setValue(child?.data?.comment || '');
            newGroupForm.get('input').setValue(child?.data?.value || '');
            newGroupForm.get('reason').setValue(child?.data?.reason || '');

          } else if (optionId == "2") {
            const cdaForm = this.multiForm.get('Site_Feasibility') as FormGroup;
            const newGroupForm = cdaForm.get('4') as FormGroup;
            newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
              // Enable the comment field if the status is 'Comment'
              if (statusValue === 'Comment') {
                newGroupForm.get('comment').enable();
                newGroupForm.get('reason').disable();
              } else if (statusValue === 'No') {
                newGroupForm.get('reason').enable();
                newGroupForm.get('comment').disable();
              } else {
                newGroupForm.get('comment')?.disable();
                newGroupForm.get('comment')?.setValue('');
                newGroupForm.get('reason')?.disable();
                newGroupForm.get('reason')?.setValue('');
                // Disable and clear the comment field if status is not 'Comment'
                // newGroupForm.get('comment').disable();
                // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
              }
            });

            newGroupForm.get('status').setValue(child?.data?.status || '');
            newGroupForm.get('comment').setValue(child?.data?.comment || '');
            newGroupForm.get('input').setValue(child?.data?.value || '');
            newGroupForm.get('reason').setValue(child?.data?.reason || '');

          } else if (optionId == "5") {
            const cdaForm = this.multiForm.get('CTA') as FormGroup;
            if (child.id == 6) {
              const newGroupForm = cdaForm.get('6') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  // newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  // newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                  newGroupForm.get('input').enable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('input')?.disable();
                  newGroupForm.get('input')?.setValue('');
                  // newGroupForm.get('reason')?.disable();
                  // newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 7) {
              const newGroupForm = cdaForm.get('7') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  // newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  // newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                  newGroupForm.get('input').enable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('input')?.disable();
                  newGroupForm.get('input')?.setValue('');
                  // newGroupForm.get('reason')?.disable();
                  // newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              newGroupForm.get('input').setValue(child?.data?.value || '');
              // newGroupForm.get('reason').setValue(child?.data?.reason || '');

            } else if (child.id == 8) {
              const newGroupForm = cdaForm.get('8') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  // newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  // newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                  newGroupForm.get('input').enable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('input')?.disable();
                  newGroupForm.get('input')?.setValue('');
                  // newGroupForm.get('reason')?.disable();
                  // newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            }
          } else if (optionId == "9") {
            const cdaForm = this.multiForm.get('DOCUMENT_SUBMISSION_TO_PI') as FormGroup;
            if (child.id == 10 || child.id == 81) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                  // newGroupForm.get('input').enable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  // newGroupForm.get('input')?.disable();
                  // newGroupForm.get('input')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 46) {
              const newGroupForm = cdaForm.get('46') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'Yes') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                  // newGroupForm.get('input').enable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  // newGroupForm.get('input')?.disable();
                  // newGroupForm.get('input')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(JSON.parse(child?.data?.reason) || '');
            }
          } else if (optionId == "13") {
            const cdaForm = this.multiForm.get('EC_Submission') as FormGroup;

            if (child.id == 21) {
              const newGroupForm = cdaForm.get('21') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 22) {
              const newGroupForm = cdaForm.get('22') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('input').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('input').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('input')?.disable();
                  newGroupForm.get('input')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              newGroupForm.get('input').setValue(child?.data?.value || '');
              // newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 23) {
              const newGroupForm = cdaForm.get('23') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Approved') {
                  newGroupForm.get('date').enable();
                  // newGroupForm.get('comment').disable();
                }else if(statusValue==='Queries raised'){
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('date').disable();
                }
                else {
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                  newGroupForm.get('reason').disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              // newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('date').setValue(child?.data?.date || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');

            } else if (child.id == 24) {
              const newGroupForm = cdaForm.get('24') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
              
            } else if (child.id == 25) {
              const newGroupForm = cdaForm.get('25') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
            }else if (child.id == 82) {
              const newGroupForm = cdaForm.get('82') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
            }else if (child.id == 83) {
              const newGroupForm = cdaForm.get('83') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
            }
            else if (child.id == 84) {
              const newGroupForm = cdaForm.get('84') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
            }
            else if (child.id == 85) {
              const newGroupForm = cdaForm.get('85') as FormGroup;
              newGroupForm.get('input').valueChanges.subscribe((inputValue) => {
                // Enable the date field if 'input' value is '1' (Yes)
                if (inputValue === 1) {
                  newGroupForm.get('date').enable();
                } else {
                  // Disable and clear the date field if 'input' value is not '1' (No)
                  newGroupForm.get('date')?.disable();
                  newGroupForm.get('date')?.setValue('');
                }
              });
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              newGroupForm.get('date').setValue(child?.data?.date || '');
            }
          } else if (optionId == "14") {
            const cdaForm = this.multiForm.get('CTRI_Done') as FormGroup;

            if (child.id == 26) {
              const newGroupForm = cdaForm.get('26') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 27) {
              const newGroupForm = cdaForm.get('27') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            }
          } else if (optionId == "16") {
            const cdaForm = this.multiForm.get('SITE_INITATION_VISIT_DONE') as FormGroup;

            if (child.id == 32) {
              const newGroupForm = cdaForm.get('32') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 33) {
              const newGroupForm = cdaForm.get('33') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 34) {
              const newGroupForm = cdaForm.get('34') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            }
          } else if (optionId == "17") {
            const cdaForm = this.multiForm.get('RUNNING_STATUS') as FormGroup;

            if (child.id == 42) {
              const newGroupForm = cdaForm.get('42') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 68) {
              const newGroupForm = cdaForm.get('68') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 91) {
              const newGroupForm = cdaForm.get('91') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 69) {
              const newGroupForm = cdaForm.get('69') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 86) {
              const newGroupForm = cdaForm.get('86') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 70) {
              const newGroupForm = cdaForm.get('70') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 71) {
              const newGroupForm = cdaForm.get('71') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 72) {
              const newGroupForm = cdaForm.get('72') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 73) {
              const newGroupForm = cdaForm.get('73') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 73) {
              const newGroupForm = cdaForm.get('73') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 74) {
              const newGroupForm = cdaForm.get('74') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              if(child?.data?.sub_data && child?.data?.sub_data.length > 0){
                child.data.sub_data = JSON.parse(child?.data?.sub_data);
                const newGroupFormSubData = newGroupForm.get('sub_data') as FormGroup;
                newGroupForm.get('input').valueChanges.subscribe((statusValue) => {
                  if(statusValue == 0){
                    newGroupFormSubData.get('input_7')?.setValue('');
                    newGroupFormSubData.get('input_1')?.setValue('');
                    newGroupFormSubData.get('input_2')?.setValue('');
                    newGroupFormSubData.get('input_3')?.setValue('');
                  }else{
                    newGroupFormSubData.get('input_4')?.setValue('');
                  }
                });
                newGroupFormSubData.get('input_7').setValue(parseInt(child?.data?.sub_data?.input_7) || '');
                newGroupFormSubData.get('input_1').setValue(parseInt(child?.data?.sub_data?.input_1) || 0);
                newGroupFormSubData.get('input_2').setValue(parseInt(child?.data?.sub_data?.input_2) || 0);
                newGroupFormSubData.get('input_3').setValue(parseInt(child?.data?.sub_data?.input_3) || 0);
                newGroupFormSubData.get('input_4').setValue(child?.data?.sub_data?.input_4 || '');
              }
            }else if (child.id == 89) {
              const newGroupForm = cdaForm.get('89') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            }else if (child.id == 90) {
              const newGroupForm = cdaForm.get('90') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 92) {
              const newGroupForm = cdaForm.get('92') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 75) {
              const newGroupForm = cdaForm.get('75') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
              if(child?.data?.sub_data && child?.data?.sub_data.length > 0){
                child.data.sub_data = JSON.parse(child?.data?.sub_data);
                const newGroupFormSubData = newGroupForm.get('sub_data') as FormGroup;
                newGroupFormSubData.get('input_1').setValue(child?.data?.sub_data?.input_1 || '');
              }
            }
          } else if (optionId == "18") {
            const cdaForm = this.multiForm.get('Data_Entry') as FormGroup;

            if (child.id == 36) {
              const newGroupForm = cdaForm.get('36') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 44) {
              const newGroupForm = cdaForm.get('44') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            }
          } else if (optionId == "19") {
            const cdaForm = this.multiForm.get('CSR_Sumbission') as FormGroup;

            if (child.id == 37) {
              const newGroupForm = cdaForm.get('37') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 38) {
              const newGroupForm = cdaForm.get('38') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            }
          } else if (optionId == "40") {
            const cdaForm = this.multiForm.get('Subject_Identity_Submission') as FormGroup;
            if (child.id == 41) {
              const newGroupForm = cdaForm.get('41') as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            }
          } else if (optionId == "20") {
            const cdaForm = this.multiForm.get('Close_Out') as FormGroup;
            if (child.id == 39) {
              const newGroupForm = cdaForm.get('39') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 76) {
              const newGroupForm = cdaForm.get('76') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            } else if (child.id == 77) {
              const newGroupForm = cdaForm.get('77') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            } else if (child.id == 78) {
              const newGroupForm = cdaForm.get('78') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            } else if (child.id == 79) {
              const newGroupForm = cdaForm.get('79') as FormGroup;
              newGroupForm.get('input').setValue(parseInt(child?.data?.value) || 0);
            }
          }else if (optionId == "88") {
            const cdaForm = this.multiForm.get('publication') as FormGroup;
            if (child.id == 87) {
              const newGroupForm = cdaForm.get('87') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Rejected') {
                  newGroupForm.get('comment').enable();
                  
                }else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                 
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              
            }
          } else if (optionId == "45") {
            const cdaForm = this.multiForm.get('CTRI_Updation') as FormGroup;
            if (child.id == 80) {
              const newGroupForm = cdaForm.get('80') as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            }
          } else if (optionId == "15") {
            const cdaForm = this.multiForm.get('IP_NONIP') as FormGroup;
            if (child.id == 28 || child.id == 56 || child.id == 57 || child.id == 58 || child.id == 59 || child.id == 60 || child.id == 61 || child.id == 62 || child.id == 30 || child.id == 31) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('status').valueChanges.subscribe((statusValue) => {
                // Enable the comment field if the status is 'Comment'
                if (statusValue === 'Comment') {
                  newGroupForm.get('comment').enable();
                  newGroupForm.get('reason').disable();
                } else if (statusValue === 'No') {
                  newGroupForm.get('reason').enable();
                  newGroupForm.get('comment').disable();
                } else {
                  newGroupForm.get('comment')?.disable();
                  newGroupForm.get('comment')?.setValue('');
                  newGroupForm.get('reason')?.disable();
                  newGroupForm.get('reason')?.setValue('');
                  // Disable and clear the comment field if status is not 'Comment'
                  // newGroupForm.get('comment').disable();
                  // newGroupForm.get('comment').setValue(''); // Optionally clear the comment value when disabled
                }
              });
              newGroupForm.get('status').setValue(child?.data?.status || '');
              newGroupForm.get('comment').setValue(child?.data?.comment || '');
              // newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('reason').setValue(child?.data?.reason || '');
            } else if (child.id == 29 ||child.id == 64 || child.id == 65 || child.id == 66 || child.id == 67) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
              newGroupForm.get('date').setValue(child?.data?.date || '');
              newGroupForm.get('quantity').setValue(child?.data?.quantity || '');
            } else if (child.id == 51 || child.id == 52 || child.id == 53 || child.id == 54) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('input').setValue(child?.data?.value || '');
            } else if (child.id == 43) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('status').setValue(JSON.parse(child?.data?.status) || '');
            } else if (child.id == 55) {
              child.id = child.id.toString();
              const newGroupForm = cdaForm.get(child.id) as FormGroup;
              newGroupForm.get('status').setValue(child?.data?.status || '');
            }
          }
          // Trigger change detection to update visibility
          // this.updateVisibility(cdaForm.get('status').value);
        });
        this.multiForm.updateValueAndValidity();
      }
    );
  }

  onSubmit() {

    const currentForm = this.getFormGroupByIndex(this.currentFormIndex);

    if (currentForm.valid) {
      console.log('Submitted data:', currentForm.value);
      let formData = currentForm.value;
      let finalData = { "dynamicForm": formData };
      finalData["id"] = this.routeParams.id;
      finalData["selectedOption"] = this.multiForm.value.selectedOption;
      console.log(finalData);
      // console.log(this.multiForm.value.selectedOption);
      this.apiService.post('api/createStudyCrcDetail', finalData).subscribe(response => {
        console.log('Form submitted successfully', response);
        window.alert(response.message);
        location.reload();
      });
      // You can submit the form or proceed further here
    } else {
      console.log('The current form is invalid');
    }

    /* if (this.form.valid) {
      let formData = this.form.value;
      formData["id"] = this.routeParams.id;
      this.apiService.post('api/createStudyCrcDetail', formData).subscribe(response => {
        console.log('Form submitted successfully', response);
        window.alert(response.message);
        location.reload();
      });
    } */
  }


goBack(): void {
  this.router.navigate(['/study-crc-list'], {
    queryParams: {
      page: this.currentPage,
      searchCrcName: this.searchParams.searchCrcName,
      searchStudyName: this.searchParams.searchStudyName,
      searchLocation: this.searchParams.searchLocation,
      searchAssignedBy: this.searchParams.searchAssignedBy
    }
  });
}




}
